<template>
  <div class="setup-content contact-info" id="step-7">
    <h3 class="color-darkblue">Payments</h3>
    <div class="form-row row-cols-md-4 row-cols-1">
      <div class="col form-group">
        <strong>Currency: </strong> {{ currency }}
      </div>
      <div class="col form-group">
        <strong>Payment Type: </strong> {{ payment_type }}
      </div>
    </div>
    <div class="form-row row-cols-md-4 row-cols-1">
      <div class="col form-group">
        <strong>Last Corp Audit Start Date: </strong>{{ corp_audit_start_date }}
      </div>
      <div class="col form-group">
        <strong>Last Corp Audit End Date: </strong>{{ corp_audit_end_date }}
      </div>
    </div>
    <!-- Summary Section -->
    <div class="order-summary mt-4">
      <div class="row">
        <div class="col-md-12">
          <div class="bg-white radius-5 p-3">
            <h3 class="color-darkblue">Financial Summary</h3>
            <table class="table table-sm table-bordered">
              <thead>
                <tr class="table-primary">
                  <th></th>
                  <th class="text-center"><strong>Parts</strong></th>
                  <th class="text-center"><strong>Handling</strong></th>
                  <th class="text-center"><strong>{{ labor_spelling }}</strong></th>
                  <th class="text-center"><strong>Other</strong></th>
                  <th class="text-center"><strong>Flat Amount</strong></th>
                  <th class="text-center"><strong>Total</strong></th>
                </tr>
              </thead>
              <tbody>
                <tr class="table-secondary" v-for="(row, index) in financialSummaryArr" :key="index">
                  <td class="text-center"><strong>{{ row.heading }}</strong></td>
                  <td class="text-center">{{ row.part }}</td>
                  <td class="text-center">{{ row.handling }}</td>
                  <td class="text-center">{{ row.labor }}</td>
                  <td class="text-center">{{ row.other }}</td>
                  <td class="text-center">{{ row.flat_amount }}</td>
                  <td class="text-center">{{ row.total }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <!-- Summary Section Ends -->
    <!-- Information section -->
    <h3 class="color-darkblue">Information</h3>
    <div class="form-row row-cols-md-4 row-cols-1">
      <div class="col form-group">
        <strong>Accept Date: </strong> {{ accept_date }}
      </div>
      <div class="col form-group">
        <strong>Process Date: </strong> {{ process_date }}
      </div>
      <div class="col form-group">
        <strong>Process Number: </strong> {{ process_number }}
      </div>
    </div>
    <div class="form-row row-cols-md-4 row-cols-1">
      <div class="col form-group">
        <strong>CR Memo Date: </strong> {{ cr_memo_date }}
      </div>
      <div class="col form-group">
        <strong>Tax Rates: </strong> {{ tax_rates }}
      </div>
      <div class="col form-group">
        <strong>Tax Area ID: </strong> {{ tax_area_id }}
      </div>
    </div>
    <!-- Information section ends -->
    <!-- previous claim details -->
    <h3 class="color-darkblue">Amounts Available For Based On Previous Claim</h3>
    <div class="form-row row-cols-md-4 row-cols-1">
      <div class="col form-group">
        <strong>Modified amounts avail: </strong>{{ modified_amount_avail }}
      </div>
      <div class="col form-group">
        <strong>Chargeback amounts avail: </strong>{{ chargeback_amount_avail }}
      </div>
    </div>
    <div class="form-row row-cols-md-4 row-cols-1">
      <div class="col form-group">
        <strong>Denied amounts avail: </strong>{{ denied_amount_avail }}
      </div>
      <div class="col form-group">
        <strong>Total amounts avail: </strong>{{ total_amount_avail }}
      </div>
    </div>

    <!-- previous claim details ends -->
    <template>
      <div class="alert alert-warning hide w-50">
        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span
            aria-hidden="true">&times;</span></button>
        <strong class="errormsg"></strong>
      </div>
      <div class="btn-groups mt-3">
        <button class="btn btn-primary btn-text-indent" type="button" v-on:click.prevent="gotoBack('step-6')">
          <i class="fp-left-arrow" style="font-size:20px;"> </i> Previous
        </button>
        <button class="btn btn-primary btn-text-indent" type="button" v-on:click.prevent="gotoNext('step-7')">
          Next <i class="fp-right-arrow right-icon"> </i></button>
      </div>
    </template>
  </div>
</template>
<script>
import Vue from "vue";

import { commonMixins } from '../../mixins/commonMixins';
import LoadingContent from "@/components/LoadingContent.vue";
Vue.component("loading-content", LoadingContent);

export default {
  name: "EvClaimTab",
  mixins: [commonMixins],
  data: () => ({
    financialSummaryArr: [],
    currency: "",
    payment_type: "",
    corp_audit_end_date: "",
    corp_audit_start_date: "",
    accept_date: "",
    process_date: "",
    process_number: "",
    cr_memo_date: "",
    tax_rates: "",
    tax_area_id: "",
    modified_amount_avail: 0,
    chargeback_amount_avail: 0,
    denied_amount_avail: 0,
    total_amount_avail: 0
  }),
  mounted() {
    var self = this;
    self.populateSummaryRowsOnMount();
  },
  methods: {
    gotoNext: function (flag) {
      var self = this;
      self.emitDataToParent();
      self.gotoNextStepMixins(flag);
    },
    gotoBack: function (flag) {
      var self = this;
      // todo will only call the below function when all the requried fields have been filled.
      self.gotoBackStepMixins(flag);
    },
    populateSummaryRowsOnMount() {
      var self = this;
      self.financialSummaryArr.push(
        {
          heading: "Claimed",
          part: "0",
          handling: "0",
          labor: "0",
          other: "0",
          flat_amount: "0",
          total: "0",
        },
        {
          heading: "Processed",
          part: "0",
          handling: "0",
          labor: "0",
          other: "0",
          flat_amount: "0",
          total: "0",
        },
        {
          heading: "Paid",
          part: "0",
          handling: "0",
          labor: "0",
          other: "0",
          flat_amount: "0",
          total: "0",
        },
        {
          heading: "Charged Back",
          part: "0",
          handling: "0",
          labor: "0",
          other: "0",
          flat_amount: "0",
          total: "0",
        },
        {
          heading: "Net Paid",
          part: "0",
          handling: "0",
          labor: "0",
          other: "0",
          flat_amount: "0",
          total: "0",
        },
        {
          heading: "Paid Tax",
          part: "0",
          handling: "0",
          labor: "0",
          other: "0",
          flat_amount: "0",
          total: "0",
        },
        {
          heading: "Charged Back Tax",
          part: "0",
          handling: "0",
          labor: "0",
          other: "0",
          flat_amount: "0",
          total: "0",
        },
      );
    },
    emitDataToParent() {
      var self = this;
      const dataToSend = {
        financialSummary: self.financialSummaryArr,
        financialSummaryArr: [],
        currency: self.currency,
        payment_type: self.payment_type,
        corp_audit_end_date: self.corp_audit_end_date,
        corp_audit_start_date: self.corp_audit_start_date,
        accept_date: self.accept_date,
        process_date: self.process_date,
        process_number: self.process_number,
        cr_memo_date: self.cr_memo_date,
        tax_rates: self.tax_rates,
        tax_area_id: self.tax_area_id,
        modified_amount_avail: self.modified_amount_avail,
        chargeback_amount_avail: self.chargeback_amount_avail,
        denied_amount_avail: self.denied_amount_avail,
        total_amount_avail: self.total_amount_avail
      };
      self.$emit("send-payment-data-to-parent", dataToSend);
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/warrantyClaimTabs/EvPaymentTab.vue